module.exports = __webpack_public_path__ + "img/United-Nation.1dcdddb8.png";